<div class="sticky top-0 z-20 flex justify-end pointer-events-none">
    @if (searchOpen()) {
        <mat-form-field appearance="outline" class="w-full max-w-[22rem] scale-[0.75] origin-top-right pointer-events-auto">
            <input
                #searchInput
                matInput
                placeholder="Pretraži"
                [value]="searchTerm()"
                (input)="searchTerm.set(searchInput.value); searchTree(searchInput.value)" />

            <div matSuffix class="flex items-center gap-0.5">
                <span class="whitespace-nowrap text-sm tabular-nums">
                    {{ matches().length ? (currentMatchIndex() + 1) + '/' + matches().length : '0/0' }}
                </span>
                <button type="button" class="cursor-pointer inline-flex" (click)="goToPrevious()" [disabled]="!matches().length">
                    <mat-icon>arrow_upward</mat-icon>
                </button>
                <button type="button" class="cursor-pointer inline-flex" (click)="goToNext()" [disabled]="!matches().length">
                    <mat-icon>arrow_downward</mat-icon>
                </button>
                <button type="button" class="cursor-pointer inline-flex" (click)="closeSearch()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </mat-form-field>
    } @else {
        <button mat-icon-button class="pointer-events-auto" (click)="openSearch()" title="Search">
            <mat-icon>search</mat-icon>
        </button>
    }
</div>

<mat-tree #tree [dataSource]="shownValues()" [childrenAccessor]="childrenAccessor">
    <mat-tree-node [attr.data-node-id]="node.nodeId" *matTreeNodeDef="let node" matTreeNodePadding>
        <button mat-icon-button disabled></button>
        <mat-checkbox
            [checked]="nodeStates().get(node.nodeId) === 'all'"
            (change)="toggleSimple(node)"
            labelPosition="before">
            <p [class.bg-yellow-400]="matchedIds().has(node.nodeId)">
                {{ node.label }}
            </p>
        </mat-checkbox>
    </mat-tree-node>

    <mat-tree-node
        [attr.data-node-id]="node.nodeId"
        *matTreeNodeDef="let node; when: hasChild"
        matTreeNodePadding
        [cdkTreeNodeTypeaheadLabel]="node.label">
        @let state = nodeStates().get(node.nodeId);

        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.label">
            <mat-icon class="mat-icon-rtl-mirror">
                {{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
        </button>

        @if (threeStateCheckbox() === false) {
            <mat-checkbox
                [checked]="state === 'all'"
                [indeterminate]="state === 'partial'"
                (change)="toggleSimple(node)"
                labelPosition="before">
                <p [class.bg-yellow-400]="matchedIds().has(node.nodeId)">
                    {{ node.label }}
                </p>
            </mat-checkbox>
        } @else {
            <span
                (click)="cycleParent(node)"
                class="cursor-pointer"
                tabindex="0"
                role="checkbox"
                [attr.aria-checked]="state === 'partial' ? 'mixed' : (state !== 'unchecked')"
                (keydown.enter)="cycleParent(node)"
                (keydown.space)="$event.preventDefault(); cycleParent(node)">
                <mat-checkbox
                    [checked]="state === 'all' || state === 'self'"
                    [indeterminate]="state === 'partial'"
                    [class.opacity-50]="state === 'self'"
                    [title]="state === 'self' ? 'Odabrana je samo ova jedinica, bez podređenih' : ''"
                    tabindex="-1"
                    style="pointer-events: none"
                    labelPosition="before">
                    <p [class.bg-yellow-400]="matchedIds().has(node.nodeId)">
                        {{ node.label }}
                    </p>
                </mat-checkbox>
            </span>
        }
    </mat-tree-node>
</mat-tree>
